import { render } from "./CatalogMain.vue?vue&type=template&id=04c9b391&scoped=true"
import script from "./CatalogMain.vue?vue&type=script&lang=js"
export * from "./CatalogMain.vue?vue&type=script&lang=js"

import "./CatalogMain.vue?vue&type=style&index=0&id=04c9b391&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c9b391"]])

export default __exports__